export const MUNI_DEMINIMIS = [
    {display:'Above De Minimis Only', value:'offeringDeMinStatus=above'},
    {display:'Below De Minimis Only', value:'offeringDeMinStatus=below'},
].map(a => {
    a.label = a.display
    return a
})


// WEBPACK FOOTER //
// ./src/twd/values/muni-deminimis.js